import React from 'react';
import { View, Text, TouchableOpacity, Modal } from 'react-native';
import { useTheme } from '../context/ThemeContext';
import UserBreakVideoPlayer from './UserBreakVideoPlayer';
import { hasUserBreakVideos } from '../utils/userBreakVideoLinks';

export default function UserBreakVideosModal({
  visible,
  onClose,
  title,
  videoLinks,
  overlayStyle,
  contentStyle,
}) {
  const theme = useTheme();

  if (!hasUserBreakVideos(videoLinks)) return null;

  const defaultOverlay = {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.65)',
    justifyContent: 'center',
    padding: 20,
  };
  const defaultContent = {
    backgroundColor: theme.isDarkMode ? theme.colors.surface : '#FFFFFF',
    borderRadius: 12,
    padding: 16,
    maxWidth: 720,
    width: '100%',
    alignSelf: 'center',
  };

  return (
    <Modal visible={visible} transparent animationType="slide" onRequestClose={onClose}>
      <View style={[defaultOverlay, overlayStyle]}>
        <View style={[defaultContent, contentStyle]}>
          <TouchableOpacity
            style={{ alignSelf: 'flex-end', padding: 8 }}
            onPress={onClose}
            accessibilityLabel="Close video"
          >
            <Text style={{ fontSize: 22, color: theme.colors.text, fontWeight: '600' }}>✕</Text>
          </TouchableOpacity>
          <Text
            style={{
              fontSize: 18,
              fontWeight: '600',
              color: theme.colors.text,
              marginBottom: 12,
            }}
          >
            {title || 'Break video'}
          </Text>
          <UserBreakVideoPlayer videoLinks={videoLinks} title={title} theme={theme} />
        </View>
      </View>
    </Modal>
  );
}
